import { formatInTimeZone } from 'date-fns-tz';

const timeZone = 'Europe/Paris';

const groupedType = ['TERRAIN', 'POSTE'];
const groupedActivity = ['TENNIS_TABLE'];

const frenchFormatedDate = (t, date, dateFormat, options = {}) => formatInTimeZone(date ? new Date(date) : new Date(), t || timeZone, dateFormat, options);

const computeSessionLabel = (session) => {
  return session.activity_type && groupedType.includes(session.activity_type) && session.group && (session.group !== 'NONE' || groupedActivity.includes(session.groupCode)) ? session.group : session.type;
}

export { frenchFormatedDate, groupedType, groupedActivity, computeSessionLabel };
